import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlaceholderImage from "src/components/Placeholder";
import { Link } from "react-router-dom";

function EvoDiwaliCashRewardsPromoFun(props: any) {
    const {
        app: { brandId },
        theme,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPK = brandId && (brandId === 35 || brandId === 36 || brandId === 37 || brandId === 49);

    const minQualifyingDepositAmt =  isPK ? "PKR 9,000" : "₹3,000";

    const maxBonusAmt =  isPK ? "PKR 3,000" : "₹1,000";

    return (
        <>
            <InformationWrapper>
                {/* =========================
                    TOP CONTENT
                ========================== */}
                <TopSection>
                    <h1>Bet & Get Your Share of ₹2 Crore in Cash Rewards!</h1>

                    <p className="top-para">
                        Play Evolution's <strong>Super Andar Bahar, Dragon Tiger,</strong> and <strong>Teen Patti</strong> and earn cash rewards based <br /> on your eligible bets.
                    </p>

                    <GamesImageWrapper className="gameImages">
                        <Link to="/live-casino/evolution/super-andar-bahar">
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.evoDCMGameThumbs01}`}
                                alt="Super Andar Bahar"
                            />
                        </Link>

                        <Link to="/live-casino/evolution/dragon-tiger-1">
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.evoDCMGameThumbs02}`}
                                alt="Dragon Tiger"
                            />
                        </Link>

                        <Link to="/live-casino/evolution/teenpatti">
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.evoDCMGameThumbs03}`}
                                alt="Teen Patti"
                            />
                        </Link>
                    </GamesImageWrapper>
                </TopSection>

                {/* =========================
                    HOW TO CLAIM
                ========================== */}
                <Section>
                    <h2>How To Claim</h2>

                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.evoDCWPointsDesk}`}
                            alt="How To Claim"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Section>

                <PrizeSection>
                    <h2>Weekly Betting Tiers & Cash Rewards</h2>

                    <ImageWrapper className="prizeTable">
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.evoDCMTableDesk}`}
                            alt="Prize Table"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                    <br />
                    <br />
                    <p><strong>Rewards are cumulative!</strong> Qualify for a higher tier and receive the rewards from all lower tiers as well.</p>
                </PrizeSection>

                {/* =========================
                    TERMS & CONDITIONS
                ========================== */}
                <TermsSection>
                    <TermsLeft>
                         <img
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.evoDCMTermsLeftDesk}`}
                            alt="Terms Head"
                        />
                    </TermsLeft>
                    <TermsList>
                        <li>
                            The promotion runs from{" "}
                            <strong>
                                1 November to 31 December.
                            </strong>
                        </li>

                        <li>
                            The total cash reward pool for the promotion is <strong>₹2 Crore</strong>
                        </li>

                        <li>
                            Eligible bets are calculated weekly, from <strong>Monday to Sunday</strong>.
                        </li>

                        <li>
                            Only valid bets placed on <strong> Evolution's Super Andar Bahar, Dragon Tiger, and Teen Patti </strong> count towards the wagering calculation.
                        </li>

                        <li>
                            Rewards are cumulative. Players who qualify for a higher tier will also receive the rewards from all lower tiers.
                        </li>

                        <li>
                            Each player can receive rewards only once per month during the promotion period. If a player qualifies in multiple weeks within the same month, only one reward will be awarded for that month, based on the highest qualifying tier achieved in a single week.
                            
                        </li>

                        <li>
                            Rewards are credited in accordance with the promotion's reward schedule.
                        </li>

                        <li>The promotion is subject to the applicable terms and conditions.</li>
                    </TermsList>
                </TermsSection>
            </InformationWrapper>
        </>
    );
}

export default withTheme(withAppContext(EvoDiwaliCashRewardsPromoFun));

/* =========================================================
   MAIN WRAPPER
========================================================= */

const InformationWrapper = styled.div`
    width: calc(100% - 2.4em);
    min-height: 100vh;
    height: auto;
    padding: 3rem 0 4rem;
    margin: 0 1.2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #EBEBEB;
    overflow: hidden;
    position: relative;

    h1,
    h2,
    p {
        margin: 0;
        padding: 0;
    }

    h1,
    h2 {
        width: 100%;
        color: ${theme('palette.evoDCRPromoHead')};
        text-align: center;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    h1 {
        font-size: 19px;
        text-transform: capitalize;
    }

    h2 {
        font-size: 20px;
        text-transform: capitalize;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin: 0;
        padding: 2rem 15px 3rem;
        background-position: top center;

        h1 {
            font-size: 17px;
            line-height: 28px;
        }

        h2 {
            font-size: 19px;
        }
    }

    @media (max-width: 480px) {
        h1 {
            font-size: 17px;
            line-height: 25px;
        }

        h2 {
            font-size: 18px;
        }
    }
`;

/* =========================================================
   TOP SECTION
========================================================= */

const TopSection = styled.div`
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin-bottom: 3.8rem;
    background-color: #fff;
    padding: 25px 10px;
    border-radius: 10px;

    .top-para {
        width: 100%;
        max-width: 900px;
        color: #444;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-transform: capitalize;
    }

    .top-para strong {
        font-weight: 700;
    }

    .promotion-period {
        color: #444;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
    }

    .promotion-period strong {
        font-weight: 700;
    }

    .gameImages {
     
    }

    @media (max-width: 768px) {
        gap: 1.4rem;
        margin-bottom: 3rem;

        .top-para,
        .promotion-period {
            font-size: 14px;
            line-height: 21px;
        }

        .desktop-break {
            display: none;
        }
    }
`;

/* =========================================================
   COMMON SECTION
========================================================= */

const Section = styled.section`
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.5rem;
    background-color: #fff;
    padding: 25px 10px;
    border-radius: 10px;

    @media (max-width: 768px) {
        margin-bottom: 2.8rem;
    }

    .prizeTable {
        width: 70%;
    }
`;

const PrizeSection = styled.section`
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.5rem;


    @media (max-width: 768px) {
        margin-bottom: 2.8rem;
    }

    .prizeTable {
        width: 70%;
    }
`;

/* =========================================================
   HOW TO CLAIM IMAGE
========================================================= */

const ImageWrapper = styled.div`
    width: 80%;
    max-width: 1250px;
    margin: 2rem auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    img {
        width: 100%;
        height: auto;
        display: block;
    }

    @media (max-width: 992px) {
        width: 75%;
    }

    @media (max-width: 768px) {
        width: 95%;
        margin-top: 1.5rem;
    }
`;

const GamesImageWrapper = styled.div`
    width: 60%;
    max-width: 950px;
    margin: 2rem auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    & a {
        width: 30%;
       & img {
            width: 90%;
            height: auto;
            display: block;
       }
    }
   

    @media (max-width: 992px) {
        width: 75%;
    }

    @media (max-width: 768px) {
        width: 95%;
        margin-top: 1.5rem;
    }
`

/* =========================================================
   TERMS & CONDITIONS
========================================================= */

const TermsList = styled.ul`
    width: 60%;
    max-width: 630px;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
    margin: 2rem auto 0;
    padding: 0;
    list-style: none;

    li {
        position: relative;
        color: #444;
        background: #EBEBEB;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        text-align: left;
        line-height: 25px;
        text-transform: capitalize;
        padding: 10px 1.5rem 10px 2.7rem;
    }

    li::before {
        content: "✦";
        position: absolute;
        left: 1.5rem;
        top: 10px;
        color: #444;
        font-size: 13px;
    }

    li strong {
        font-weight: 700;
    }

    @media (max-width: 992px) {
        width: 60%;
    }

    @media (max-width: 768px) {
        width: 90%;
        margin-top: 1.5rem;

        li {
            font-size: 14px;
            line-height: 22px;
            padding: 10px 14px 10px 34px;
        }

        li::before {
            left: 15px;
        }
    }

    @media (max-width: 480px) {
        width: 95%;

        li {
            font-size: 13px;
            line-height: 20px;
        }
    }
`;

const TermsLeft = styled.div`
    width: 40%;
    display: flex;
    justify-content: flex-end;

    & img {
        width: 70%;
        height: auto;
    }
`

const TermsSection = styled.div`
  width : 90%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  padding: 15px 10px;
  border-radius: 10px;
`